import React, { useEffect, useState } from 'react'
import { getDateNow , convertDateToString } from '../utils'

export const ContextRollCall = React.createContext<any>({})


export default function ContextRollCallModels(props: any) {
    const [jsonParmsRollCall, setJsonParmsRollCall] = useState<any>({ 'from': getDateNow(), 'to': getDateNow() , 'page':1 , 'user':[] })
    const [activeFilterRollCall, setActiveFilterRollCall] = useState<any>({
        'activePeriod': -1 ,
        'displayDelay':true ,
        'displayOvertime':true ,
        'displayWork':true ,
        'location':-1 ,
        'user':[],
        'startCalender':convertDateToString(getDateNow()) ,
        'endCalender':convertDateToString(getDateNow()) ,
    })




    return (
        <ContextRollCall.Provider value={{
            activeFilterRollCall,
            setActiveFilterRollCall ,
            jsonParmsRollCall ,
            setJsonParmsRollCall
        }}>
            {props.children}
        </ContextRollCall.Provider>
    )
}